"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Pricing_vue_1 = __importDefault(require("../../pages/pricing/Pricing.vue"));
const NewPricing_vue_1 = __importDefault(require("../../pages/pricing/NewPricing.vue"));
const PercentPricing_vue_1 = __importDefault(require("../../pages/pricing/PercentPricing.vue"));
const FixedPricing_vue_1 = __importDefault(require("../../pages/pricing/FixedPricing.vue"));
exports.default = [
    {
        name: "pricing",
        path: "/pricing",
        component: Pricing_vue_1.default,
        meta: { requiresAuth: true, title: "Pricing" },
    },
    {
        name: "new_pricing",
        path: "/pricing/new",
        component: NewPricing_vue_1.default,
        meta: { requiresAuth: true, title: "New Pricing" },
    },
    {
        name: "percent_pricing",
        path: "/pricing/percent",
        component: PercentPricing_vue_1.default,
        meta: { requiresAuth: true, title: "Percent Pricing" },
    },
    {
        name: "fixed_pricing",
        path: "/pricing/fixed",
        component: FixedPricing_vue_1.default,
        meta: { requiresAuth: true, title: "Fixed Pricing" },
    },
    {
        name: 'customer_pricings_api',
        path: '/api/customer-pricings/:id(\\d+)?',
        redirect: '',
        meta: { requiresAuth: true }
    },
    {
        name: 'create_customer_pricing_api',
        path: '/api/create-customer-pricing',
        redirect: '',
        meta: { requiresAuth: true }
    },
    {
        name: 'create_customer_pricing_filter_api',
        path: '/api/create-customer-pricing-filter',
        redirect: '',
        meta: { requiresAuth: true }
    },
    {
        name: 'customer_pricing_filters_api',
        path: '/api/customer-pricing-filters/:id(\\d+)?',
        redirect: '',
        meta: { requiresAuth: true }
    },
    {
        name: 'customer-pricing-conflict-check_api',
        path: '/api/customer-pricing-conflict-check/:id(\\d+)?',
        redirect: '',
        meta: { requiresAuth: true }
    },
    {
        name: 'customer_pricing_filters_delete_api',
        path: '/api/customer-pricing-filters-delete',
        redirect: '',
        meta: { requiresAuth: true }
    }
];
